import { useAtomValue } from 'jotai';

import { manipulatorState_CarryStateToJSON } from 'lib/generated/proto/bosdyn/api/robot_state';

import {
  carryStateSelector,
  gripperHoldingItemSelector,
  gripperOpeningPercentageSelector,
} from './selectors';

export function useCarryState() {
  const carryState = useAtomValue(carryStateSelector);
  const _carryStateString = manipulatorState_CarryStateToJSON(carryState);
  return { carryState, _carryStateString };
}

export function useGripperHoldingItem() {
  const gripperHoldingItem = useAtomValue(gripperHoldingItemSelector);
  return { gripperHoldingItem };
}

export function useGripperOpeningPercentage() {
  const openingPercentage = useAtomValue(gripperOpeningPercentageSelector);
  return { openingPercentage };
}
